import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default {

  name: 'accordion-block',

  props: {
    block: {}
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/accordionBlock/AccordionBlock.js